import { api } from "./client.js";
const demo = import.meta.env.VITE_DEMO_MODE === "true";
const DEMO_INBOX = {
    items: [
        {
            id: "i1", matchId: "m1", read: false,
            createdAt: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
            kind: "defense", outcome: "win",
            opponent: { firstName: "RaiderBot", isBot: true, rating: 600 },
            ratingDelta: 8, myHpPct: 64, oppHpPct: 0, totalTicks: 19, endReason: "elimination",
        },
        {
            id: "i2", matchId: "m2", read: false,
            createdAt: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
            kind: "defense", outcome: "loss",
            opponent: { firstName: "Virtual", isBot: false, rating: 1075 },
            ratingDelta: -12, myHpPct: 0, oppHpPct: 38, totalTicks: 23, endReason: "elimination",
        },
        {
            id: "i3", matchId: "m3", read: true,
            createdAt: new Date(Date.now() - 1000 * 60 * 60 * 6).toISOString(),
            kind: "offense", outcome: "win",
            opponent: { firstName: "ShieldBot", isBot: true, rating: 500 },
            ratingDelta: 6, myHpPct: 78, oppHpPct: 0, totalTicks: 16, endReason: "elimination",
        },
    ],
};
export const inboxApi = {
    list: (limit = 30) => demo
        ? Promise.resolve(DEMO_INBOX)
        : api.get(`/inbox?limit=${limit}`),
    unreadCount: () => demo
        ? Promise.resolve({ count: 2 })
        : api.get("/inbox/unread-count"),
    read: (id) => demo
        ? Promise.resolve({ ok: true })
        : api.post(`/inbox/${id}/read`),
    readAll: () => demo
        ? Promise.resolve({ ok: true, updated: 0 })
        : api.post("/inbox/read-all"),
};
